import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'search-box-item',
})
export default class SearchBoxItem extends Vue {

    @Prop({ type: String, required: false, default: '' }) labelName!: string;

    get name(){
        return this.labelName ?? '';
    }
}